import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SkillLevels } from 'src/app/models/skillslevels/skillslevels';
import { SkillLevelsService } from 'src/app/services/skilllevels.service';



@Component({
  selector: 'app-skilllevels-modal',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './skilllevels-modal.component.html',
  styleUrl: './skilllevels-modal.component.css'
})
export class SkillLevelsModalComponent implements OnInit{
  form: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<SkillLevelsModalComponent>,
    public SkillLevelsService: SkillLevelsService,
    public _toastService: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any    
  ) {
    
    this.buildForm();

    if(this.data?.item){
      this.form.patchValue({...this.data?.item}); 
    }
    if(this.data?.view){
      this.form.disable();
    }

  } 

  ngOnInit(): void {
    
  }

  private buildForm(){
    this.form = this.fb.group({
          id: new FormControl(0),
          name: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
          rating: new FormControl(0, [Validators.required, Validators.min(1)]),
    })
  }

  Accept() {
   
    const SkillLevelsModel = this.form?.value as SkillLevels;
    
    if(this.form.invalid) {
      this._toastService.error("Por favor, complete todos los campos requeridos.");
      return;
    }

    if(this.data.mode == 'add' || this.data.mode == 'edit'){         
      this.save(SkillLevelsModel);  
    }else if(this.data.mode == 'delete'){
      this.delete(SkillLevelsModel.id);
    }
  }
  save(SkillLevelsModel: SkillLevels){    
    this.SkillLevelsService.addSkillLevels(SkillLevelsModel).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos guardados")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }
  delete(id: number){    
    this.SkillLevelsService.deleteSkillLevels(id).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos eliminados correctamente!")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }

}
